import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { supabase } from "../services/adminApi";

export default function Topbar({ onMenuToggle }) {
  const [email, setEmail] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    supabase.auth.getUser().then(({ data }) => {
      setEmail(data?.user?.email || "");
    });
  }, []);

  const handleLogout = async () => {
    await supabase.auth.signOut();
    navigate("/admin/login");
  };

  return (
    <header className="admin-topbar">
      <button
        className="menu-toggle"
        onClick={onMenuToggle}
        aria-label="Toggle menu"
      >
        ☰
      </button>
      <div className="topbar-right">
        {email && (
          <Link to="/admin/account" className="topbar-user" title="Account settings">
            {email}
          </Link>
        )}
        <button onClick={handleLogout}>Logout</button>
      </div>
    </header>
  );
}
